
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.517 4.909A6.757 6.757 0 016.765.742a6.75 6.75 0 016.75 6.758A6.758 6.758 0 11.517 4.909zm11.546 4.645a5.736 5.736 0 00.368-2.054 5.666 5.666 0 00-1.204-3.563c-.319.531-.92 1.324-1.664 1.324a2.387 2.387 0 00-.85.085v.078c0 .128.347.475.53.659.46.342.765.851.85 1.417 0 1.133.114 1.48.213 1.565a4.59 4.59 0 011.757.489zM1.098 7.5a5.667 5.667 0 011.176-3.485c.2.366.588.59 1.006.58.573.29 1.08.695 1.487 1.19-.3.185-.572.412-.807.673l-.071.07c-.196.19-.476.463-.595.469a1.19 1.19 0 00-1.225 1.225c0 .081.02.161.056.234l.638 1.275a7.41 7.41 0 00.347 2.16A5.667 5.667 0 011.098 7.5zm3.733 5.326a5.67 5.67 0 001.934.34v.022a5.667 5.667 0 004.816-2.621 4.694 4.694 0 00-1.352-.418c-1.226 0-1.226-1.757-1.226-2.607 0-.128-.316-.443-.51-.638l-.028-.028a2.182 2.182 0 01-.843-1.416c0-1.226 1.247-1.226 1.912-1.226.185-.007.624-.531.893-1.055a5.667 5.667 0 00-7.289-.028c.01.06.01.123 0 .184.007.17.085.17.163.17.85 0 2.755 1.728 2.784 2.536a.637.637 0 01-.709.637c-.127.007-.474.354-.658.538a2.21 2.21 0 01-1.417.85c-.057 0-.142 0-.142.071l.617 1.183a.538.538 0 01.056.234c0 .772.17 2.026.539 2.401.257.223.42.534.46.871z","fill":"#585858"}})])
          )
        }
      }
    